const r = {
  /**
   * @deprecated
   */
  deprecated: {
    fonts: {
      chineseTraditional: "Noto Sans TC, sans-serif",
      chineseSimplified: "Noto Sans SC, sans-serif"
    },
    breakpoints: {
      xs: 400,
      sm: 480,
      md: 576,
      lg: 768,
      lgLandscape: 850,
      xl: 1025,
      xxl: 1200,
      xxxl: 1400,
      xxxxl: 1620
    },
    tokens: {
      // 'grey': '#9b9c9b',
      // 'midGrey': '#e5e1e6',
      // 'darkGrey': '#363a36',
      "icon.secondary": "#bcb9cf",
      "interactive.main": "#386E9B",
      "status.error.background": "#FADEDE",
      "action.hoverBackground": "#EDECF2",
      "other.backDropOverlay": "#808080",
      "infographics.green.dark": "#064B12",
      "infographics.green.light": "rgba(66, 200, 89, 0.15)",
      "infographics.blue.dark": "#21145F",
      "infographics.blue.light": "rgba(7, 123, 231, 0.09)",
      "infographics.red.dark": "#5C0606",
      "infographics.red.light": "rgba(224, 34, 34, 0.15)",
      "infographics.orange.dark": "#6D5000",
      "infographics.orange.light": "rgba(233, 181, 0, 0.15)",
      "infographics.grey.dark": "#424242",
      "infographics.grey.light": "#EEEEEE",
      "infographics.violet.dark": "#21145F",
      "infographics.violet.light": "#E0DDED",
      "midGrey.primary": "#9089AF",
      stennGrey: "#9B9C9B",
      "text.tertiary": "#747674",
      startColorMainGradient: "#f8c37b",
      endColorMainGradient: "#524ebc"
    }
  }
}, e = {
  common: {
    white: {
      value: "#ffffff",
      type: "color"
    },
    black: {
      value: "#000000",
      type: "color"
    },
    lightGrey: {
      value: "#f6f6f6",
      type: "color"
    },
    darkGrey: {
      value: "#797979",
      type: "color"
    },
    grey20: {
      value: "#79797920",
      type: "color"
    },
    primary20: {
      value: "#8980ff20",
      type: "color"
    },
    primary: {
      value: "#8980ff",
      type: "color"
    }
  }
};
export {
  e as deprecatedCommonPaletteGroup,
  r as deprecatedTheme
};
//# sourceMappingURL=deprecatedTheme.mjs.map
